var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentPasteOff, CopyAll } from '@mui/icons-material';
import { ContentPaste } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useCallback } from 'react';
import { useAlertStore } from '../../store/alerts';
import { useSettingsCopyStore } from '../../store/settingsCopyStore';
import { colors } from '../../styles/MuiTheme';
import { convertToListDiff } from '../../utils/ListDiffUtils';
import { SmartTooltip } from '../SmartTooltip';
export var CopyInputSettings = function (_a) {
    var input = _a.input, configToCopy = _a.configToCopy, onChange = _a.onChange;
    var addAlert = useAlertStore().addAlert;
    var _b = useSettingsCopyStore(), copiedInput = _b.copiedInput, pasteableConfig = _b.pasteableConfig, setSettingsCopy = _b.setSettingsCopy;
    var canPaste = (copiedInput === null || copiedInput === void 0 ? void 0 : copiedInput.type) === input.type && pasteableConfig !== null;
    var doCopy = useCallback(function () {
        console.log('doCopy', configToCopy);
        setSettingsCopy(input, configToCopy);
        var formattedConfig = JSON.stringify(configToCopy);
        navigator.clipboard
            .writeText(formattedConfig)
            .then(function () {
            addAlert({
                children: "".concat(input.label, " ").concat(input.type, " settings copied to clipboard"),
                severity: 'success',
            });
        })
            .catch(function () {
            addAlert({
                children: "Failed to copy ".concat(input.label, " ").concat(input.type, " settings to clipboard"),
                severity: 'error',
            });
        });
    }, [configToCopy, onChange]);
    return (_jsxs("div", __assign({ style: { display: 'flex', gap: 2, alignItems: 'center' } }, { children: [_jsx(SmartTooltip, __assign({ enabledTitle: "Copy Settings and Defaults", disabledTitle: "", enabled: true }, { children: _jsx(IconButton, __assign({ component: "div", onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        doCopy();
                    } }, { children: _jsx(CopyAll, { sx: { color: colors.rsOrange } }) })) })), _jsx(SmartTooltip, __assign({ enabledTitle: "Paste Settings", disabledTitle: "No settings copied", enabled: canPaste }, { children: _jsxs(IconButton, __assign({ component: "div", disabled: !canPaste, onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        if (input.type.endsWith('list')) {
                            var currentOpts = configToCopy.map(function (v) {
                                if (typeof v === 'string') {
                                    return v;
                                }
                                return v.value;
                            });
                            var pastedOpts = pasteableConfig.map(function (v) {
                                if (typeof v === 'string') {
                                    return v;
                                }
                                return v.value;
                            });
                            var diff = convertToListDiff(pastedOpts, currentOpts);
                            if (input.type === 'stringlist') {
                                onChange(diff);
                            }
                            else if (input.type === 'enumlist') {
                                onChange(__assign(__assign({}, diff), { added: diff.added.filter(function (v) {
                                        return input.enum.includes(v);
                                    }), removed: diff.removed.filter(function (v) {
                                        return input.enum.includes(v);
                                    }) }));
                            }
                        }
                        else if (input.type === 'style') {
                            onChange(pasteableConfig);
                        }
                        setSettingsCopy(null, null);
                    } }, { children: [canPaste && (_jsx(ContentPaste, { sx: {
                                color: colors.rsOrange,
                            } })), !canPaste && (_jsx(ContentPasteOff, { sx: {
                                color: 'grey',
                            } }))] })) }))] })));
};
